<main id="main" class="main">
  <div class="row m-1">
    <div
      class="col-12 col-md-12 d-flex justify-content-between"
      style="background: #5d7c9b !important; font-size: 14px"
    >
      <h6 class="title">
        PDS (Preauthorized Debit Service) &nbsp;&nbsp;
        <i class="bi bi-info-circle"></i>
      </h6>
    </div>
  </div>

  <div class="row m-1">
    <div class="col-12 col-md-2">
      <div class="form-group">
        <label for="filterReportType">View</label>
        <div>
          <input
            type="radio"
            id="scheduled"
            name="type"
            [value]="'SCHEDULED'"
            [(ngModel)]="type"
            (change)="onTypeChange()"
          />
          <label class="form-check-label ps-1 my-auto" for="scheduled">
            Scheduled
          </label>
          &nbsp;
          <input
            type="radio"
            id="history"
            name="type"
            [value]="'HISTORY'"
            [(ngModel)]="type"
            (change)="onTypeChange()"
          />
          <label class="form-check-label ps-1 my-auto" for="history">
            History
          </label>
        </div>
      </div>
    </div>

    <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          {{ type === "SCHEDULED" ? "Month for Schedule" : "Date range" }}
        </label>
        <input
          *ngIf="type === 'HISTORY'; else elseMonthRange"
          type="text"
          [(ngModel)]="date"
          class="form-control"
          placeholder="Select Month"
          bsDaterangepicker
          [bsConfig]="{ rangeInputFormat: 'MMM YYYY', minMode: 'month' ,showWeekNumbers: false}"
          [maxDate]="maxDateForPicker"
        />
        <ng-template #elseMonthRange>
          <input
            type="text"
            [(ngModel)]="date"
            class="form-control"
            placeholder="Select Month"
            bsDatepicker
            [bsConfig]="{dateInputFormat: 'MM-DD-YYYY',showWeekNumbers: false}"
            [maxDate]="maxDateForPicker"
          />
        </ng-template>
      </div>
    </div>

    <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="filterReportType"></label>
        <div class="d-flex gap-2 mb-3">
          <button
            class="btn btn-primary"
            style="font-size: 12px"
            (click)="applyFilters()"
            title="Apply Filters"
          >
            Apply filter
          </button>

          <button
            class="btn btn-secondary"
            style="font-size: 12px"
            (click)="resetFilters()"
            title="Reset Filters"
          >
            Reset filter
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="row m-1 mt-4" *ngIf="isView">
    <div class="table-responsive">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        id="DataTables_Table_1"
        class="table text-nowrap"
      >
        <thead>
          <tr>
            <th style="width: 30px">Cust ID</th>
            <th>Member Name</th>
            <th>Invoice Link</th>
            <th>Amount</th>
            <th>Bank Details</th>
            <th>Scheduled Date</th>
            <th>Status</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>1</td>
            <td>Test</td>
            <td>Download</td>
            <td>100$</td>
            <td>1234</td>
            <td>2024-01-01</td>
            <td>Pending</td>
            <td>
              <div style="min-width: 20px" data-bs-target="showmemberlist">
                <a
                  class="viewicon"
                  title="View Detail"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                >
                  Suspend indefinite
                </a>
                <a
                  class="viewicon"
                  title="View Detail"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                >
                  Suspend and defer till date
                </a>
                <a
                  class="viewicon"
                  title="View Detail"
                  data-toggle="tooltip"
                  style="cursor: pointer; margin-right: 10px"
                >
                Reactivate deferred
                </a>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>
